/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Hide/Show floating checkout button when prescription modal opens/closes
$(document).on('click', '[data-action="open-modal"]', function() {
  $('.js-subtotal-wrapper').addClass('is-hidden');
});

$(document).on('click', '[data-action="close-modal"]', function(e) {
  // イベントの伝播を確実に停止
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  // フローティングチェックアウトボタンを表示
  $('.js-subtotal-wrapper').removeClass('is-hidden');

  // デバッグ用ログ（本番環境では削除可）
  console.log('Modal close button clicked - event propagation stopped');

  // falseを返してイベントの伝播を完全に防ぐ
  return false;
});

// Also remove is-hidden when modal is closed by ESC key
$(document).on('keyup', function(e) {
  if (e.key === 'Escape') {
    $('.js-subtotal-wrapper').removeClass('is-hidden');
  }
});

// Change cart prescription
$(".product-form__change-button").click(function (e) {
  // 商品ページかカートページかを判定（data-line属性がない = 商品ページ）
  var isProductPage = !$(this).attr("data-line");

  /*
    text input validation - check data-required fields
  */
  var requiredTextInputs = document.querySelectorAll('input[type="text"][data-required="true"]');
  var hasTextError = false;
  var errorMessage = "テキストフィールドを入力してください。";

  for(var i = 0; i < requiredTextInputs.length; i++) {
    var input = requiredTextInputs[i];
    if(!input.value || input.value.trim() === '') {
      hasTextError = true;

      // Check if the associated label contains "電話番号"
      var fieldset = input.closest('fieldset');
      if(fieldset) {
        var h3 = fieldset.querySelector('h3');
        if(h3 && h3.textContent.includes('電話番号')) {
          errorMessage = "電話番号を入力してください。";
        }
      }
      break;
    }
  }

  if(hasTextError) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    window.alert(errorMessage);
    return false;
  }

  /*
    chekboxを1つでも選択しているか
  */
  var checkedCounts = document.getElementsByClassName("checkbox");
  var isChecked = false;
  for(i=0; i < checkedCounts.length; i++) {
    if(checkedCounts[i].checked){
      isChecked = true;
      break;
    }
  }
  if(isChecked){
    // 商品ページの場合: typeをsubmitに変更してフォーム送信を許可
    if(isProductPage) {
      $(this).attr("type", "submit");
      return true;
    }

    // カートページの場合: 既存の処理
    let line_item = $(this).attr("data-line");
    let line_quantity = $(this).attr("data-quantity");
    const form_data = $(this).parents(".modal__dialog").find("form").serializeArray();
    const line_properties = {};
    for (key in form_data) {
      if (form_data[key].name.startsWith("birthday-year")) {
        var year = form_data[key].value;
      }else if (form_data[key].name.startsWith("birthday-month")) {
        var month = form_data[key].value;
      }else if (form_data[key].name.startsWith("birthday-day")) {
        var day = form_data[key].value;
        line_properties['_【問診票】お誕生日'] = year + month + day;
      }else if (form_data[key].name.startsWith("properties")) {
        line_properties[form_data[key].name.replace(/^.+\[|\]/g, "")] = form_data[key].value;
      }
      var checkboxes = form_data.filter((e, i) => form_data.find((e2, j) => e.name === e2.name && i !== j));
      var checkbox_value = checkboxes.map(function (checkbox) {
        return checkbox.value;
      }).join(",");
    }
    if (checkboxes && checkboxes.length > 0) {
      line_properties[checkboxes[0].name.replace(/^.+\[|\]/g, "")] = checkbox_value;
    }
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line: line_item,
        quantity: line_quantity,
        properties: line_properties
      },
      dataType: 'json',
    }).success(function (data) {
      location.reload();
    }).error(function (data) {
      location.reload();
    });
  }else{
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    window.alert("全ての項目に回答してください。");
    return false;
  }
});

window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});